<div class="row p-1">
  <label>Tutti i campi contrassegnati con <span class="required"></span> sono obbligatori</label>
</div>
